import React, { useEffect, useState } from "react";
import { Button, FormControl, InputGroup } from "react-bootstrap";
import { useDebounce } from "./usedebounce";
import "./search.scss";
import { IconSearch, IconClear } from "../icons";

export const Search = ({
  placeholder = "Search Student",
  label = "Search for student name",
  onChange = () => {},
  className = "",
  style = {},
  defaultValue = "",
  testid
}) => {
  const [searchFor, setSearchFor] = useState(defaultValue);

  const run = useDebounce(500);

  useEffect(() => {
    run(() => {
      if (onChange) {
        onChange(searchFor);
      }
    });
  }, [searchFor]);

  return (
    <div style={{ ...style }} className={`${className} mpng-search`} {...(testid ? { "data-testid": testid } : {})}>
      <div className="filter-icon">
        <InputGroup>
          <InputGroup.Text>
            <IconSearch />
          </InputGroup.Text>
          <FormControl
            aria-label={label}
            className={searchFor ? "filter-input" : "filter-input-empty"}
            placeholder={placeholder}
            value={searchFor}
            onChange={(ev) => setSearchFor(ev.target.value)}
          />
          {searchFor ? (
            <Button
              variant=""
              className="mpng-btn"
              aria-label="clear search"
              onClick={() => {
                setSearchFor("");
              }}
            >
              <IconClear />
            </Button>
          ) : (
            <></>
          )}
        </InputGroup>
      </div>
    </div>
  );
};

export default Search;
